import React from 'react';
import classNames from 'classnames';

import styles from '../MobileCard.module.scss';

import { DateHelper } from '@utils/DateHelper';

import { MobileCardData, MobileField, MobileFieldsOfLane, MobileFieldTypes } from '../../types';
import { Title } from './Title';

export function DateField<D extends MobileCardData>(field: MobileField<D>, dataItem: D): React.ReactElement<any> {
    const date = DateHelper.toLocalStringDate(new Date(dataItem[field.accessor] as string | number | Date));

    return (
        <div
            className={classNames([
                styles.field,
                field.isPrimary && styles.fieldPrimary,
                field.fieldsOnLane === MobileFieldsOfLane.SingleField && styles.singleOnLane,
                field.fieldsOnLane === MobileFieldsOfLane.PairField && styles.pairOnLane,
            ])}
        >
            {!field.withoutTitle && Title(field, dataItem)}
            <div
                id={dataItem.id}
                className={classNames([
                    styles.textValue,
                    field.isPrimary && styles.textValuePrimary,
                    field.fieldType === MobileFieldTypes.Phone && styles.textPhone,
                ])}
            >
                {date}
            </div>
        </div>
    );
}
